import Vue from 'vue';

import CfsFilterSelectComponent from '@/framework/inputs/CfsFilterSelectComponent.vue';
import CfsDateField from './inputs/CfsDateFieldComponent.vue';
import CfsDatePicker from './inputs/CfsDatePickerComponent.vue';
import CfsSelect from './inputs/CfsSelectComponent.vue';
import CfsTextField from './inputs/CfsTextFieldComponent.vue';
import CfsCheckbox from './inputs/CfsCheckboxComponent.vue';
import CfsTextArea from './inputs/CfsTextAreaComponent.vue';
import CfsUploadFileArea from './inputs/CfsUploadFileAreaComponent.vue';
import CfsTimeField from './inputs/CfsTimeFieldComponent.vue';
import CfsFileField from './inputs/CfsFileFieldComponent.vue';
import CfsAutocomplete from './inputs/CfsAutocompleteComponent.vue';
import CfsDropdownComponent from '@/framework/inputs/CfsDropdownComponent.vue';
import CfsSwitchComponent from '@/framework/inputs/CfsSwitchComponent.vue';
import CfsChipGroup from '@/framework/inputs/CfsChipGroup.vue';
import CfsChip from '@/framework/inputs/CfsChip.vue';
import CfsTable from '@/framework/elements/table/CfsTableComponent.vue';
import CfsVirtualTable from '@/framework/elements/table/CfsVirtualTable.vue';
import CfsVirtualFilters from '@/framework/elements/CfsVirtualFilters.vue';

import CfsExpansion from './elements/CfsExpansionComponent.vue';
import CfsPageHeader from './elements/CfsPageHeaderComponent.vue';
import CfsDialog from './elements/CfsDialogComponent.vue';
import CfsStickyFooter from './elements/CfsStickyFooterComponent.vue';
import CfsPerfectScrollbar from '@/framework/elements/CfsPerfectScrollbar.vue';
import CfsTelephoneInput from '@/framework/inputs/CfsTelephoneInput.vue';
import CfsIcon from '@/framework/elements/CfsIcon.vue';
import CfsFormGroup from '@/framework/elements/CfsFormGroup.vue';
import CfsCustomChipGroup from '@/framework/inputs/CfsCustomChipGroup.vue';
import CfsBreadcrumbs from '@/framework/elements/CfsBreadcrumbs.vue';
import CfsLoadingOverlay from '@/framework/elements/loading/CfsLoadingOverlay.vue';
import CfsTableActionsMenu from '@/framework/elements/table/actions/CfsTableActionsMenu.vue';
import CfsLoading from '@/framework/elements/loading/CfsLoading.vue';
import CfsDrawer from '@/framework/elements/CfsDrawer.vue';
import CfsChipStatus from '@/framework/elements/chip/CfsChipStatus.vue';
import CfsUltimateBreadcrumbs from '@/framework/elements/breadcrumbs/CfsUltimateBreadcrumbs.vue';
import CfsPdf from '@/framework/elements/CfsPdf.vue';
import CfsTabs from '@/framework/elements/CfsTabs.vue';
import CfsTooltip from '@/framework/elements/CfsTooltip.vue';
import CfsCombobox from '@/framework/inputs/CfsCombobox.vue';
import CfsVirtualDragTable from '@/framework/elements/table/CfsVirtualDragTable.vue';
import CfsCurrencyTextField from './inputs/CfsCurrencyTextFieldComponent.vue';
import CfsDateInputComponent from './inputs/CfsDateInputComponent.vue';

/** Inputs */
Vue.component('CfsDateField', CfsDateField);
Vue.component('CfsSelect', CfsSelect);
Vue.component('CfsTextField', CfsTextField);
Vue.component('CfsCurrencyTextField', CfsCurrencyTextField);
Vue.component('CfsCheckbox', CfsCheckbox);
Vue.component('CfsTextArea', CfsTextArea);
Vue.component('CfsUploadFileArea', CfsUploadFileArea);
Vue.component('CfsTimeField', CfsTimeField);
Vue.component('CfsFileField', CfsFileField);
Vue.component('CfsAutocomplete', CfsAutocomplete);
Vue.component('CfsDropdown', CfsDropdownComponent);
Vue.component('CfsSwitch', CfsSwitchComponent);
Vue.component('CfsChipGroup', CfsChipGroup);
Vue.component('CfsTelephoneInput', CfsTelephoneInput);
Vue.component('CfsFilterSelect', CfsFilterSelectComponent);
Vue.component('CfsCombobox', CfsCombobox);
Vue.component('CfsChip', CfsChip);

/** Elements */
Vue.component('CfsIcon', CfsIcon);
Vue.component('CfsTooltip', CfsTooltip);
Vue.component('CfsTabs', CfsTabs);
Vue.component('CfsTable', CfsTable);
Vue.component('CfsVirtualTable', CfsVirtualTable);
Vue.component('CfsVirtualDragTable', CfsVirtualDragTable);
Vue.component('CfsVirtualFilters', CfsVirtualFilters);
Vue.component('CfsDialog', CfsDialog);
Vue.component('CfsExpansion', CfsExpansion);
Vue.component('CfsFormGroup', CfsFormGroup);
Vue.component('CfsPageHeader', CfsPageHeader);
Vue.component('CfsLoading', CfsLoading);
Vue.component('CfsBreadcrumbs', CfsBreadcrumbs);
Vue.component('CfsUltimateBreadcrumbs', CfsUltimateBreadcrumbs);
Vue.component('CfsStickyFooter', CfsStickyFooter);
Vue.component('CfsLoadingOverlay', CfsLoadingOverlay);
Vue.component('CfsTableActionsMenu', CfsTableActionsMenu);
Vue.component('CfsPerfectScrollbar', CfsPerfectScrollbar);
Vue.component('CfsCustomChipGroup', CfsCustomChipGroup);
Vue.component('CfsDrawer', CfsDrawer);
Vue.component('CfsChipStatus', CfsChipStatus);
Vue.component('CfsPdf', CfsPdf);
Vue.component('CfsDatePicker', CfsDatePicker);
Vue.component('CfsDateInputComponent', CfsDateInputComponent);
